/* Special Art Books · catalogo (sections/sab-c-main.liquid) · JS vanilla in custom element, nessuna libreria.
   Porting di html-finale/sito/assets/js/sab-collection.js (catalogo v1.2). In Shopify filtri, conteggi, ordinamento e pagine li
   fa il server (Search & Discovery, sort_by, paginate 24): qui niente card nascoste né riordinate in JS.
   <sab-collection> aggiunge solo:
   - aggiornamento senza ricaricare con la Section Rendering API (?section_id=…) per modulo dei filtri, pillole, chip, «Clear all»
     e ordinamento; l'URL resta condivisibile con i parametri nativi (filter.p.m.book.*, sort_by);
   - pannello «Filter & sort»: lo stesso <form> sta nella colonna da desktop (≥ 64rem) e nel <dialog> da telefono e tablet;
   - «Load more»: la pagina dopo viene aggiunta in fondo alla griglia, il focus va sul primo libro nuovo;
   - blocco del pappagallino dopo 3 righe (2 da desktop) e «pop» una volta sola quando entra nello schermo;
   - la pillola attiva resta in vista nella sua fila.
   <sab-c-rail>: frecce sotto le file che scorrono («Series to collect», «More to explore»).
   Senza JS tutto funziona con link e GET. */
(() => {
  'use strict';

  const desktopMQ = window.matchMedia('(min-width: 64rem)');
  const reducedMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  if (!customElements.get('sab-collection')) {
    class SabCollection extends HTMLElement {
      connectedCallback() {
        if (this.isWired) return;
        this.isWired = true;
        this.sectionId = this.dataset.sectionId;
        this.form = this.querySelector('[data-plp-form]');
        this.side = this.querySelector('[data-plp-side]');
        this.dialog = this.querySelector('[data-plp-dialog]');
        this.dialogBody = this.dialog ? this.dialog.querySelector('[data-plp-dialog-body]') : null;
        this.bar = this.querySelector('[data-plp-bar]');
        this.controller = null;

        this.place = this.place.bind(this);
        this.onResize = this.onResize.bind(this);

        this.addEventListener('click', (event) => this.onClick(event));
        if (this.form) {
          this.form.addEventListener('change', (event) => {
            const input = event.target;
            if (!(input instanceof HTMLInputElement)) return;
            this.applyForm(desktopMQ.matches);
          });
          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.applyForm(desktopMQ.matches);
          });
        }
        const sortForm = this.querySelector('[data-plp-sort-form]');
        if (sortForm) sortForm.addEventListener('submit', (event) => event.preventDefault());
        const sortSelect = this.querySelector('[data-plp-sort]');
        if (sortSelect) {
          sortSelect.addEventListener('change', () => {
            const radio = this.form && [...this.form.querySelectorAll('input[name="sort_by"]')].find((r) => r.value === sortSelect.value);
            if (radio) {
              radio.checked = true;
              this.applyForm(false);
            } else {
              this.update(this.urlFrom(new FormData(sortForm)), { scroll: false });
            }
          });
        }
        if (this.dialog) {
          this.dialog.addEventListener('close', () => {
            document.documentElement.classList.remove('sab-has-dialog');
            if (this.dialogTrigger && document.contains(this.dialogTrigger)) this.dialogTrigger.focus();
          });
        }

        desktopMQ.addEventListener('change', this.place);
        window.addEventListener('resize', this.onResize);
        this.place();
        this.afterRender();
      }

      disconnectedCallback() {
        desktopMQ.removeEventListener('change', this.place);
        window.removeEventListener('resize', this.onResize);
        if (this.observer) this.observer.disconnect();
        if (this.controller) this.controller.abort();
      }

      /* URL con i parametri nativi; sort_by si toglie quando è l'ordine di default della collezione */
      urlFrom(formData) {
        const params = new URLSearchParams();
        for (const [key, value] of formData) {
          if (typeof value !== 'string' || value === '') continue;
          if (key === 'sort_by' && value === this.dataset.defaultSort) continue;
          params.append(key, value);
        }
        const query = params.toString();
        return `${this.dataset.url}${query ? `?${query}` : ''}`;
      }

      applyForm(scroll) {
        if (!this.form) return;
        this.update(this.urlFrom(new FormData(this.form)), { scroll });
      }

      onClick(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const link = target.closest('a[data-plp-link]');
        if (link && this.contains(link)) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          this.update(link.href, { scroll: false, from: link });
          return;
        }

        const more = target.closest('a[data-plp-more-btn]');
        if (more) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          this.loadMore(more);
          return;
        }

        const opener = target.closest('[data-plp-open]');
        if (opener) {
          this.openDialog(opener);
          return;
        }
        if (!this.dialog) return;
        if (target.closest('[data-plp-close]')) {
          this.dialog.close();
          return;
        }
        if (target.closest('[data-plp-show]')) {
          this.dialog.close();
          if (this.bar && this.bar.getBoundingClientRect().top < 0) this.bar.scrollIntoView({ block: 'start', behavior: 'auto' });
          return;
        }
        if (target === this.dialog) this.dialog.close();   // clic sul fondo
      }

      openDialog(trigger) {
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.place();
        this.dialogTrigger = trigger;
        this.dialog.showModal();
        document.documentElement.classList.add('sab-has-dialog');
        const close = this.dialog.querySelector('[data-plp-close]');
        if (close) close.focus();
      }

      /* Il modulo vive nella colonna da desktop e nel dialog da telefono e tablet */
      place() {
        if (this.form) {
          if (desktopMQ.matches) {
            if (this.side && this.form.parentNode !== this.side) this.side.append(this.form);
            if (this.dialog && this.dialog.open) this.dialog.close();
          } else if (this.dialogBody && this.form.parentNode !== this.dialogBody) {
            this.dialogBody.append(this.form);
          }
        }
        this.placePromo();
      }

      onResize() {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.placePromo(), 120);
      }

      /* Section Rendering API: si sostituiscono solo le parti che cambiano */
      async update(url, { scroll = false, from = null } = {}) {
        if (this.controller) this.controller.abort();
        const controller = new AbortController();
        this.controller = controller;

        /* focus da ritrovare dopo il cambio: stessa posizione nella stessa parte */
        let focusKey = null;
        const active = from || document.activeElement;
        if (active instanceof Element && this.contains(active)) {
          const part = active.closest('[data-plp-swap]');
          if (part) {
            const items = [...part.querySelectorAll('a, button, input, select')];
            focusKey = { part: part.dataset.plpSwap, index: items.indexOf(active) };
          } else if (active instanceof HTMLInputElement && this.form && this.form.contains(active)) {
            focusKey = { input: [active.name, active.value] };
          } else if (active.closest('details[data-group]') && active.tagName === 'SUMMARY') {
            focusKey = { group: active.closest('details[data-group]').dataset.group };
          }
        }

        const fetchUrl = new URL(url, window.location.href);
        fetchUrl.searchParams.set('section_id', this.sectionId);
        this.classList.add('is-loading');
        this.setAttribute('aria-busy', 'true');
        let html = '';
        try {
          const response = await fetch(fetchUrl, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error(String(response.status));
          html = await response.text();
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          window.location.assign(url);
          return;
        } finally {
          if (this.controller === controller) {
            this.classList.remove('is-loading');
            this.removeAttribute('aria-busy');
          }
        }
        const next = parse(html).querySelector('sab-collection');
        if (!next) {
          window.location.assign(url);
          return;
        }
        this.swap(next);

        const clean = new URL(url, window.location.href);
        clean.searchParams.delete('section_id');
        clean.searchParams.delete('page');
        window.history.replaceState(window.history.state, '', `${clean.pathname}${clean.search}${window.location.hash}`);

        this.restoreFocus(focusKey);
        if (scroll && this.bar && this.bar.getBoundingClientRect().top < 0 && !(this.dialog && this.dialog.open)) {
          this.bar.scrollIntoView({ block: 'start', behavior: reducedMQ.matches ? 'auto' : 'smooth' });
        }
      }

      swap(next) {
        next.querySelectorAll('[data-plp-swap]').forEach((source) => {
          const key = source.dataset.plpSwap;
          const target = this.querySelector(`[data-plp-swap="${key}"]`);
          if (!target) return;
          if (key === 'count' || key === 'show') {
            if (target.textContent !== source.textContent) target.textContent = source.textContent;
            return;
          }
          target.replaceWith(source);
        });

        /* Modulo dei filtri: contenuto nuovo, stessi gruppi aperti */
        const nextForm = next.querySelector('[data-plp-form]');
        if (nextForm && this.form) {
          const open = {};
          this.form.querySelectorAll('details[data-group]').forEach((d) => { open[d.dataset.group] = d.open; });
          this.form.innerHTML = nextForm.innerHTML;
          this.form.querySelectorAll('details[data-group]').forEach((d) => {
            if (d.dataset.group in open) d.open = open[d.dataset.group];
          });
        }

        /* Ordinamento a tendina e link «Clear all» della colonna e del pannello */
        const select = this.querySelector('[data-plp-sort]');
        const nextSelect = next.querySelector('[data-plp-sort]');
        if (select && nextSelect) select.value = nextSelect.value;
        const clearHref = next.querySelector('.sab-filters__clear');
        const clear = this.querySelector('.sab-filters__clear');
        if (clear && clearHref) clear.href = clearHref.getAttribute('href');

        this.afterRender();
      }

      restoreFocus(key) {
        if (!key) return;
        let el = null;
        if (key.part) {
          const part = this.querySelector(`[data-plp-swap="${key.part}"]`);
          if (part && !part.hidden) {
            const items = [...part.querySelectorAll('a, button, input, select')];
            el = items[Math.min(key.index, items.length - 1)] || null;
          }
          if (!el && key.part === 'active') el = this.querySelector('[data-plp-open]');
        } else if (key.input && this.form) {
          el = [...this.form.querySelectorAll('input')].find((i) => i.name === key.input[0] && i.value === key.input[1]) || null;
        } else if (key.group && this.form) {
          const group = this.form.querySelector(`details[data-group="${key.group}"] > summary`);
          el = group || null;
        }
        if (el && el.offsetParent !== null) el.focus({ preventScroll: true });
      }

      /* «Load more»: la pagina dopo (24 libri) in fondo alla griglia */
      async loadMore(button) {
        if (button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');
        const url = new URL(button.href, window.location.href);
        url.searchParams.set('section_id', this.sectionId);
        let next = null;
        try {
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error(String(response.status));
          next = parse(await response.text()).querySelector('sab-collection');
        } catch (error) {
          next = null;
        }
        if (!next) {
          window.location.assign(button.href);
          return;
        }
        const grid = this.querySelector('[data-plp-grid]');
        const items = [...next.querySelectorAll('[data-plp-grid] > [data-plp-item]')];
        items.forEach((item) => grid.append(item));
        const nextMore = next.querySelector('[data-plp-swap="more"]');
        const more = this.querySelector('[data-plp-swap="more"]');
        if (nextMore && more) more.replaceWith(nextMore);
        const firstLink = items[0] && items[0].querySelector('a');
        if (firstLink) firstLink.focus({ preventScroll: false });
      }

      afterRender() {
        this.placePromo();
        this.observePromo();
        this.revealActivePills();
      }

      /* Il blocco del pappagallino va dopo 3 righe (2 da desktop, dove le colonne sono 4) */
      placePromo() {
        const grid = this.querySelector('[data-plp-grid]');
        const promo = grid ? grid.querySelector(':scope > [data-plp-promo]') : null;
        if (!promo) return;
        const items = [...grid.querySelectorAll(':scope > [data-plp-item]')];
        if (!items.length) {
          promo.hidden = true;
          return;
        }
        const cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 2;
        const k = cols * (cols >= 4 ? 2 : 3);
        promo.hidden = false;
        const after = items[Math.min(k, items.length) - 1];
        if (after.nextElementSibling !== promo) after.after(promo);
      }

      /* Il pappagallino spunta quando il blocco entra nello schermo (una volta sola) */
      observePromo() {
        const promo = this.querySelector('[data-plp-promo]');
        if (!promo || promo.classList.contains('is-in') || !('IntersectionObserver' in window)) return;
        if (this.observer) this.observer.disconnect();
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              this.observer.disconnect();
            }
          });
        }, { threshold: 0.5 });
        this.observer.observe(promo);
      }

      /* La pillola scelta resta in vista nella sua fila (anche quando arriva dall'URL) */
      revealActivePills() {
        this.querySelectorAll('.sab-plp__short .sab-chips').forEach((row) => {
          const on = row.querySelector('[aria-current="true"]');
          if (!on || row.scrollWidth <= row.clientWidth) return;
          const pad = parseFloat(getComputedStyle(row).paddingInlineStart) || 0;
          const item = on.closest('li') || on;
          const left = item.offsetLeft;
          if (left < row.scrollLeft + pad || left + item.offsetWidth > row.scrollLeft + row.clientWidth - pad) row.scrollLeft = left - pad;
        });
      }
    }
    customElements.define('sab-collection', SabCollection);
  }

  /* File orizzontali delle sezioni del catalogo: le frecce scorrono di una card */
  if (!customElements.get('sab-c-rail')) {
    class SabCRail extends HTMLElement {
      connectedCallback() {
        if (this.isWired) return;
        this.track = this.querySelector('[data-rail-track]');
        this.prev = this.querySelector('[data-rail-prev]');
        this.next = this.querySelector('[data-rail-next]');
        if (!this.track || !this.prev || !this.next) return;
        this.isWired = true;
        this.update = this.update.bind(this);
        const step = () => {
          const first = this.track.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
          return (first ? first.getBoundingClientRect().width : 240) + gap;
        };
        const behavior = () => (reducedMQ.matches ? 'auto' : 'smooth');
        this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: behavior() }));
        this.next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: behavior() }));
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }

      update() {
        if (!this.track) return;
        this.prev.disabled = this.track.scrollLeft < 8;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth > this.track.scrollWidth - 8;
      }
    }
    customElements.define('sab-c-rail', SabCRail);
  }
})();
